/**
 * IMPORTANT!!!
 * This is an autogenerated file from the Vite layouts-loader plugin.
 * It will be overwritten on every build, do not modify it manually.
 */

import { type App, defineAsyncComponent } from 'vue';

export const setupLayoutComponents = (app: App) => {
  app.component(
    'LayoutApprovalsSettingsDefault',
    defineAsyncComponent(() => import('@/approvals/layouts/layout-approvals-settings-default.vue'))
  );

  app.component(
    'LayoutCcpMfe',
    defineAsyncComponent(() => import('@/ccp-mfe/layouts/layout-ccp-mfe.vue'))
  );

  app.component(
    'LayoutCompCycle',
    defineAsyncComponent(() => import('@/ccpv2/layouts/layout-comp-cycle.vue'))
  );

  app.component(
    'LayoutDefault',
    defineAsyncComponent(() => import('@/layouts/layout-default.vue'))
  );

  app.component(
    'LayoutEmpty',
    defineAsyncComponent(() => import('@/layouts/layout-empty.vue'))
  );

  app.component(
    'LayoutLogin',
    defineAsyncComponent(() => import('@/login/layouts/layout-login.vue'))
  );

  app.component(
    'LayoutMarketDataSettings',
    defineAsyncComponent(() => import('@/market-data/layouts/layout-market-data-settings.vue'))
  );

  app.component(
    'LayoutMarketData',
    defineAsyncComponent(() => import('@/market-data/layouts/layout-market-data.vue'))
  );

  app.component(
    'LayoutPeople',
    defineAsyncComponent(() => import('@/people/layouts/layout-people.vue'))
  );

  app.component(
    'LayoutRanges',
    defineAsyncComponent(() => import('@/ranges/layouts/layout-ranges.vue'))
  );

  app.component(
    'LayoutSettings',
    defineAsyncComponent(() => import('@/settings/layouts/layout-settings.vue'))
  );
};
